export const BREAKPOINTS = {
    xs: 0, // mobile
    sm: 450, // tablet
    md: 768, // laptop
    lg: 1024, // wide
    xl: 1280, // desktop
};

export const CONTACT = {
    EMAIL: 'kunekune.contact@gmail.com',
    RGPD_EMAIL: 'rgpd@kunekune.fr',
    PHONE: '+335 67 80 23 79',
};

/** Informations légale sur l'entreprise KuneKune: https://www.societe.com/societe/kunekune-952415974.html */
export const KUNEKUNE_INFO = {
    NAME: 'KUNEKUNE',
    ID: '952 415 974',
    REGISTRAR_SHORT: 'RCS de Bordeaux',
    REGISTRAR: 'Registre du Commerce et des Sociétés de Bordeaux',
    ADDRESS: '2 allée du Doyen Georges Brus, 33600 Pessac, France',
    CAPITAL: 1000,
    VAT: 'FR 26 952 415 974',
};

export const KUNEKUNE_PUBLISHER = {
    NAME: 'Benjamin Daniel',
    EMAIL: 'kunekune.fr+publisher@gmail.com',
    PHONE: '+335 67 80 23 79',
};

export const OVH_INFO = {
    NAME: 'OVH',
    ID: '424 761 419',
    REGISTRAR_SHORT: 'RCS de Lille Métropole',
    REGISTRAR: 'Registre du Commerce et des Sociétés de Lille Métropole',
    ADDRESS: '2 rue Kellermann - 59100 Roubaix – France',
    CAPITAL: 10_174_560,
    VAT: 'FR 22 424 761 419',
};

export const VERCEL_INFO = {
    NAME: 'Vercel Inc.',
    ADDRESS: '440 N Barranca Ave 4133, Covina, CA 91723',
    EMAIL: 'privacy@vercel.com',
};
